module.exports = __webpack_public_path__ + "img/bank-kasikorn-02.39cea17a.png";